// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/SageUI-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/SageUI-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/SageUI-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Sage UI Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: 'Sage UI Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: 'Sage UI Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

input[type='range'] {
  border-radius: 0.375rem;

  width: 100%;
  margin: 5px 0;
  outline: none;
  -webkit-appearance: none;
}

input[type='range']::-webkit-slider-runnable-track {
  background-color: var(--colorsUtilityMajor075);
  border-radius: 0.375rem;
  height: 0.375rem;
  color: var(--colorsActionMinor500);

  border: 0;
  width: 100%;
  cursor: pointer;
  background-image: linear-gradient(to right, currentColor 0%, currentColor var(--slider-value), transparent var(--slider-value), transparent 100%);
}

input[type='range']::-webkit-slider-thumb {
  background-color: var(--colorsActionMinor500);
  height: 1rem;
  width: 1rem;
  border-radius: 1rem;

  margin-top: -5px;
  border: 0;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type='range']::-moz-range-track {
  background-color: var(--colorsUtilityMajor075);
  border-radius: 0.375rem;
  height: 0.375rem;

  border: 0;
  width: 100%;
  cursor: pointer;
}

input[type='range']::-moz-range-progress {
  background-color: var(--colorsActionMinor500);
  height: 0.375rem;
  border-radius: 0.375rem;
}

input[type='range']::-moz-range-thumb {
  background-color: var(--colorsActionMinor500);
  height: 1rem;
  width: 1rem;
  border-radius: 1rem;

  border: 0;
  cursor: pointer;
}

input[type='range']::-ms-track {
  height: 0.375rem;

  background: transparent;
  border-color: transparent;
  border-width: 5px 0;
  color: transparent;
  width: 100%;
  cursor: pointer;
}

input[type='range']::-ms-fill-lower {
  background-color: var(--colorsActionMinor500);
  border-radius: 0.75rem;

  border: 0;
}

input[type='range']::-ms-fill-upper {
  background-color: var(--colorsUtilityMajor075);
  border-radius: 0.75rem;

  border: 0;
}

input[type='range']::-ms-thumb {
  background-color: var(--colorsActionMinor500);
  height: 1rem;
  width: 1rem;
  border-radius: 1rem;

  border: 0;
  cursor: pointer;
  margin-top: 0;

  /* Needed to keep the Edge thumb centred */
}

input[type='range']:focus::-ms-fill-lower {
  background-color: var(--colorsActionMinor500);
}

input[type='range']:focus::-ms-fill-upper {
  background-color: var(--colorsActionMinor500);
}

/* TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the vertical space around the range input in IE */
@supports (-ms-ime-align: auto) {
  /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
  input[type='range'] {
    margin: 0;

    /* Edge starts the margin from the thumb, not the track as other browsers do */
  }
}

/**
 * The carbon-provider introduces a div with display:inline, which breaks page styling.
 *
 * We use the flex-wrapper to force it into display: flex;
 */
.carbon-provider-flex-wrapper, .carbon-provider-flex-wrapper > * {
    display: flex;
    flex: 1;
}
`, "",{"version":3,"sources":["webpack://./../design-system/src/components/system.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,4CAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,4CAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4CAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAGE;EAAA,uBAAiB;;EAEjB,WAAW;EACX,aAAa;EACb,aAAa;EACb;AALiB;;AASjB;EAAA,8CAA0B;EAC1B,uBAAiB;EACjB,gBAAY;EACZ,kCAA4B;;EAE5B,SAAS;EACT,WAAW;EACX,eAAe;EACf;AAR0B;;AAY1B;EAAA,6CAA0B;EAC1B,YAAU;EACV,WAAU;EACV,mBAAkB;;EAElB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf;AAR0B;;AAY1B;EAAA,8CAA0B;EAC1B,uBAAiB;EACjB,gBAAY;;EAEZ,SAAS;EACT,WAAW;EACX;AAN0B;;AAU1B;EAAA,6CAA0B;EAC1B,gBAAY;EACZ;AAF0B;;AAM1B;EAAA,6CAA0B;EAC1B,YAAU;EACV,WAAU;EACV,mBAAkB;;EAElB,SAAS;EACT;AAN0B;;AAU1B;EAAA,gBAAY;;EAEZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX;AAPY;;AAWZ;EAAA,6CAA0B;EAC1B,sBAAiB;;EAEjB;AAH0B;;AAO1B;EAAA,8CAA0B;EAC1B,sBAAiB;;EAEjB;AAH0B;;AAO1B;EAAA,6CAA0B;EAC1B,YAAU;EACV,WAAU;EACV,mBAAkB;;EAElB,SAAS;EACT,eAAe;EACf,aAAa;;EAEb,0CAA0C;AAThB;;AAa1B;EAAA;AAA0B;;AAI1B;EAAA;AAA0B;;AAG5B;+DAC+D;AAC/D;EACE,qGAAqG;EACrG;IACE,SAAS;;IAET,8EAA8E;EAChF;AACF;;AAEA;;;;EAIE;AACF;IACI,aAAa;IACb,OAAO;AACX","sourcesContent":["@font-face {\n  font-family: 'Sage UI Regular';\n  src: url('../fonts/SageUI-Regular.otf');\n}\n\n@font-face {\n  font-family: 'Sage UI Medium';\n  src: url('../fonts/SageUI-Medium.otf');\n}\n\n@font-face {\n  font-family: 'Sage UI Bold';\n  src: url('../fonts/SageUI-Bold.otf');\n}\n\ninput[type='search']::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n}\n\ninput[type='range'] {\n  @apply rounded-md;\n\n  width: 100%;\n  margin: 5px 0;\n  outline: none;\n  -webkit-appearance: none;\n}\n\ninput[type='range']::-webkit-slider-runnable-track {\n  @apply bg-utility-major-75;\n  @apply rounded-md;\n  @apply h-1.5;\n  @apply text-action-minor-500;\n\n  border: 0;\n  width: 100%;\n  cursor: pointer;\n  background-image: linear-gradient(to right, currentColor 0%, currentColor var(--slider-value), transparent var(--slider-value), transparent 100%);\n}\n\ninput[type='range']::-webkit-slider-thumb {\n  @apply bg-action-minor-500;\n  @apply h-4;\n  @apply w-4;\n  @apply rounded-2xl;\n\n  margin-top: -5px;\n  border: 0;\n  cursor: pointer;\n  -webkit-appearance: none;\n}\n\ninput[type='range']::-moz-range-track {\n  @apply bg-utility-major-75;\n  @apply rounded-md;\n  @apply h-1.5;\n\n  border: 0;\n  width: 100%;\n  cursor: pointer;\n}\n\ninput[type='range']::-moz-range-progress {\n  @apply bg-action-minor-500;\n  @apply h-1.5;\n  @apply rounded-md;\n}\n\ninput[type='range']::-moz-range-thumb {\n  @apply bg-action-minor-500;\n  @apply h-4;\n  @apply w-4;\n  @apply rounded-2xl;\n\n  border: 0;\n  cursor: pointer;\n}\n\ninput[type='range']::-ms-track {\n  @apply h-1.5;\n\n  background: transparent;\n  border-color: transparent;\n  border-width: 5px 0;\n  color: transparent;\n  width: 100%;\n  cursor: pointer;\n}\n\ninput[type='range']::-ms-fill-lower {\n  @apply bg-action-minor-500;\n  @apply rounded-xl;\n\n  border: 0;\n}\n\ninput[type='range']::-ms-fill-upper {\n  @apply bg-utility-major-75;\n  @apply rounded-xl;\n\n  border: 0;\n}\n\ninput[type='range']::-ms-thumb {\n  @apply bg-action-minor-500;\n  @apply h-4;\n  @apply w-4;\n  @apply rounded-2xl;\n\n  border: 0;\n  cursor: pointer;\n  margin-top: 0;\n\n  /* Needed to keep the Edge thumb centred */\n}\n\ninput[type='range']:focus::-ms-fill-lower {\n  @apply bg-action-minor-500;\n}\n\ninput[type='range']:focus::-ms-fill-upper {\n  @apply bg-action-minor-500;\n}\n\n/* TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out\nhow to remove the vertical space around the range input in IE */\n@supports (-ms-ime-align: auto) {\n  /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */\n  input[type='range'] {\n    margin: 0;\n\n    /* Edge starts the margin from the thumb, not the track as other browsers do */\n  }\n}\n\n/**\n * The carbon-provider introduces a div with display:inline, which breaks page styling.\n *\n * We use the flex-wrapper to force it into display: flex;\n */\n.carbon-provider-flex-wrapper, .carbon-provider-flex-wrapper > * {\n    display: flex;\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
